<template>
  <div>
    <SubNav
      :title="title"
      :description="description"
      :link="{
        text: 'Create New Role',
        href: '/users/create-role',
        class: 'text-primary text-decoration-underline',
      }"
    />
    <div class="container-fluid pb-1">
      <div class="mb-sm-4 mx-3 my-4 row">
        <div class="col-lg-12">
          <div class="border p-4">
            <div class="row">
              <div class="col">
                <h5 class="h5 text-muted font-weight-bold">All Roles</h5>
                <!-- <p>View, edit, invite and delete.</p> -->
              </div>
              <!-- <div>
                <AppLink to="/users/invite">
                  <button class="btn mr-2 float-right btn-action btn-primary shadow">
                    Invite new member
                  </button>
                </AppLink>
              </div> -->
            </div>

            <div class="row">
              <div class="col-lg-3 mb-4 mt-2">
                <span>Showing all {{ items.length }} records</span>
              </div>
              <!-- <div class="col-lg-6">
                <b-form>
                  <b-form-input placeholder="Search" type="search"></b-form-input>
                </b-form>
              </div>
              <div class="col-lg-3">
                <button class="btn mr-2 float-right btn-action btn-warning">
                  Delete
                  <b-icon icon="trash" aria-hidden="true"></b-icon>
                </button>
              </div> -->
            </div>
            <div class="border px-2" style="border-width: 4px; border-radius: 5px">
              <TableComponent
                :loading="loadingList"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                :fields="fields"
                :data="items"
                :paginate="false"
                @selected="handleSelection"
              />
            </div>
            <div class="pt-3">
              <button
                :class="[
                  'btn btn-action',
                  !selectedRoles.length ? 'disabled btn-dark' : 'btn-danger',
                ]"
                :style="{
                  pointerEvents: selectedRoles.length ? 'all' : 'none',
                  opacity: selectedRoles.length ? 1 : 0.3,
                }"
              >
                Delete Roles
                <!-- <b-icon icon="trash" aria-hidden="true"></b-icon> -->
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "../../components/Table.vue";
// import AppLink from "../../components/layout/components/Sidebar/Link.vue";
import SubNav from "../../components/SubNav.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "ListUsers",
  components: {
    TableComponent,
    // AppLink,
    SubNav,
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
      loadingList: true,
      selectedRoles: [],
      // roles: ["Super Admin", "Admin", "Data Viewer", "Data Manager"],
    };
  },
  computed: {
    ...mapGetters(["users", "roles"]),
    items() {
      return this.roles.map((role, index) => ({
        name: role.name,
        numUsers: `${this.users.filter((u) => u.role.id === role.id).length} users`,
        "action-buttons": [
          {
            text: "Edit",
            icon: "edit",
            index,
            func: () => {
              this.$router.push({ path: "edit-role", query: { role: role.id } });
            },
          },
        ],
      }));
    },
    fields() {
      return [
        { key: "name", label: "Name", sortable: true },
        { key: "numUsers", label: "Number of Users", sortable: true },
        { key: "action-buttons", label: "", sortable: false },
      ];
    },
    title() {
      return "Roles and Permissions";
    },
    description() {
      return 'List of all roles created, you can create new role. By clicking on the "Create new Role" link';
    },
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    ...mapActions("users", ["loadusers", "loadroles"]),
    /**
     *
     */
    handleSelection(items) {
      // console.log(items);
      this.selectedRoles = items;
    },
    /**
     *
     */
    async getUsers() {
      this.loadingList = true;
      try {
        if (!this.users.length) await this.loadusers();
        if (!this.roles.length) await this.loadroles();
      } catch (error) {
        console.log(error);
      }
      this.loadingList = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
